module.exports = __webpack_public_path__ + "img/suv.fb069c20.webp";